export class TypedEmitter {
    map = new Map();
    on(event, handler) {
        let set = this.map.get(event);
        if (!set) {
            set = new Set();
            this.map.set(event, set);
        }
        set.add(handler);
        return () => {
            this.map.get(event)?.delete(handler);
        };
    }
    emit(event, payload) {
        const set = this.map.get(event);
        if (!set)
            return;
        for (const handler of Array.from(set)) {
            handler(payload);
        }
    }
    clear() {
        this.map.clear();
    }
}
//# sourceMappingURL=events.js.map